import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

import constants from 'utils/constants';

import CommunityPostFooter from 'components/presenters/community/CommunityPostFooter';
import DotButton from 'components/presenters/button/DotButton';

export default function CommunityPostDetail({
    post, 
    userInfo,
    lottieOptions,
    isLikeAnimation,
    onAddLikeClick,
    onDeleteLikeClick,
    onDotClick
}) {

    if(!post) return null;
    return (
        <PostDetailBlock>
            <PostDetailHeader>
                <UserProfileImgBlock>
                    <UserProfileImg src={`${constants.imagePath}/user_profile_img/${post?.profile_img}`}/>
                </UserProfileImgBlock>
                <PostInfoBlock>
                    <WriterNickname>{post?.nickname}</WriterNickname>
                    <CreateDate>{format(new Date(post?.create_date), 'yyyy/MM/dd, HH:mm')}</CreateDate>
                </PostInfoBlock>
                {userInfo?.id === post?.user_no && (
                    <DotBtnBlock>
                        <DotButton onClick={onDotClick}/>
                    </DotBtnBlock>
                )}
            </PostDetailHeader>
            <PostDetailBody>
                <PostContent>{post?.content}</PostContent>
                {post?.img_attachment ? (
                    post?.img_attachment.map((image, index) => {
                        return (
                            <PostImgContentBlock key={`post-img-attachment-${index}`}>
                                <img src={`${constants.imagePath}/campaign_post_img/${image}`}/>
                            </PostImgContentBlock>
                        )
                    })
                ) : null}
            </PostDetailBody>
            <CommunityPostDetailFooter>
                <CommunityPostFooter 
                    post={post}
                    lottieOptions={lottieOptions}
                    isLikeAnimation={isLikeAnimation}
                    currPostNo={post['no']}
                    onAddLikeClick={onAddLikeClick}
                    onDeleteLikeClick={onDeleteLikeClick}
                />
            </CommunityPostDetailFooter>
        </PostDetailBlock>
    )
}

const PostDetailBlock = styled.div`
    width: 100%;
`;

const PostDetailHeader = styled.div`
    display: flex;
    padding: calc(100vw * (9 / 375)) calc(100vw * (17 / 375));
    width: 100%;
`;

const UserProfileImgBlock = styled.div`
    width: calc(100vw * (42 / 375));
    height: calc(100vw * (42 / 375));
    min-width: calc(100vw * (42 / 375));
    min-height: calc(100vw * (42 / 375));
    border: 1px solid #c4c4c4;
    border-radius: 100%;
    overflow: hidden;
`

const UserProfileImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const PostInfoBlock = styled.div`
    width: 100%;
    margin-left: calc(100vw * (10 / 375));
`;

const DotBtnBlock = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
`;

const WriterNickname = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 700;
    line-height: calc(100vw * (20 / 375));
    color: #000000;
`;

const CreateDate = styled.span`
    font-size: calc(100vw * (12 / 375));
    font-weight: 400;
    line-height: calc(100vw * (17 / 375));
    color: #989898;
`;

const PostDetailBody = styled.div`
    padding: calc(100vw * (17 / 375))  calc(100vw * (17 / 375)) calc(100vw * (35 / 375)) calc(100vw * (17 / 375));
`;

const PostContent = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (20 / 375));
    color: #000000;
    white-space: pre-wrap;
`;

const PostImgContentBlock = styled.div`
    width: 100%;
    margin-top: calc(100vw * (8 / 375));
`;

const CommunityPostDetailFooter = styled.div`
    border-top: 1px solid #EAEAEA;
    border-bottom: 1px solid #EAEAEA;
    width: 100%;
    padding: 0 calc(100vw * (17 / 375));
`;